<template>
  <div class="device-details-box">
    <div class="base-info-box">
      <div class="device-head-cla">
        <div>{{ $t('device.deviceDetails') }}</div>
        <el-button
          @click.stop="editEvent()"
          icon="el-icon-edit"
          type="primary"
          style="height: 30px"
        >
          {{ $t('common.edit') }}</el-button
        >
      </div>

      <div class="base-info-cla">
        <div class="device-logo">
          <el-avatar :size="100" :src="deviceLogo"></el-avatar>
        </div>
        <div class="device-info-box">
          <div class="deviceName-cla">{{ deviceInfo.deviceName }}</div>
          <div class="row-info-cla">
            <div class="col-item-cla" style="wdith: 75%">
              <label> {{ $t('device.sn') }}：</label>

              <span> {{ deviceInfo.deviceSn }}</span>
            </div>

            <div style="width: 25%" class="col-item-cla">
              <label> {{ $t('device.deviceTimezone') }}：</label>
              <span>{{ deviceInfo.deviceTimezone }}</span>
            </div>
          </div>
          <div class="row-info-cla">
            <div class="col-item-cla" style="wdith: 75%">
              <label> {{ $t('device.firmwave') }}：</label>
              <span>{{ deviceInfo.firmwave }}</span>
              <el-button
                size="mini"
                class="update-btn-cla"
                icon="icon iconfont zk-icon-shengji"
                v-if="deviceVersion && deviceInfo.active !== 0"
                plain
                @click.stop="showDeviceUpdateDia"
                >  {{ deviceInfo.newFirmwave }}</el-button
              >
            </div>

            <div style="width: 25%" class="col-item-cla">
              <label> {{ $t('device.deviceModel') }} ：</label>
              <span>{{ deviceInfo.deviceModel }}</span>
            </div>
          </div>
          <div class="row-info-cla">
            <div class="col-item-cla" style="wdith: 75%">
              <label> {{ $t('device.active') }} ：</label>
              <div>
                <span
                  v-if="deviceInfo.active === 0"
                  class="unactive-cla"
                ></span>
                <span v-else class="active-cla"></span>
                <ZkDictionaryValue
                  :key="deviceInfo.active"
                  type="active"
                  :value="deviceInfo.active"
                ></ZkDictionaryValue>
              </div>
            </div>
            <div style="width: 25%" class="col-item-cla">
              <label> {{ $t('device.deviceStatus') }}：</label>
              <div>
                <span
                  v-if="deviceInfo.enable === 0"
                  class="device-disbale-cla"
                ></span>
                <span v-else class="device-online-cla"></span>
                <ZkDictionaryValue
                  :key="deviceInfo.enable"
                  type="status"
                  :value="deviceInfo.enable"
                ></ZkDictionaryValue>
              </div>
            </div>
          </div>
          <div>
            <template v-if="deviceInfo.devCategory===undefined|| deviceInfo.devCategory=== 'common'">
                <el-button
              v-if="deviceInfo.deviceType === 0 &&hasPermission('a87c7ae4a98545bb99612c7ea47097d9') "
              type="primary"
              icon="icon iconfont zk-icon-shangchuankaoqin"
              class="device-btn-cla"
              @click.stop="uploadAttDataEvent"
            >
              {{ $t('device.uploadAtt') }} </el-button
            >

            <el-button
              v-if="hasPermission('495643fc5f6e45e9b7ac87824f7d68e4')"
              type="primary"
              icon="icon iconfont zk-icon-shangchuan"
              class="device-btn-cla"
              @click.stop="uploadUserInfoEvent"
              >{{ $t('device.uploadUserInfo') }}</el-button
            >
            <el-button
              v-if="hasPermission('15f7ac84b7f6490b9616519da8f5f5ad')"
              style="color:white;background:#2072ff"
              icon="icon iconfont zk-icon-tongbu"
              class="device-btn-cla"
              @click.stop="synDataEvent"
              >{{ $t('device.synData') }}</el-button
            >
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="info-black-cla">
      <div class="network-cla">
        <div class="network-title-cla">{{ $t('device.network') }}</div>
        <div class="network-box-cla">
          <div class="network-item-cla">
            <label>{{ $t('device.remoteIp') }}：</label>
            <span>{{ deviceInfo.remoteIp }}</span>
          </div>

          <div class="network-item-cla">
            <label>{{ $t('device.localIp') }}：</label>
            <span>{{ deviceInfo.localIp }}</span>
          </div>

          <div class="network-item-cla">
            <label>{{ $t('device.macAddress') }}：</label>
            <span>{{ deviceInfo.macAddress }}</span>
          </div>

          <div class="network-item-cla">
            <label>{{ $t('device.ipLocation') }}：</label>
            <span>{{ deviceInfo.ipLocation }}</span>
          </div>
        </div>
      </div>
      <div class="usage-cla">
        <div class="usage-title-cla">{{ $t('device.deviceUser') }}</div>
        <div style="margin-top: 15px">
          <consumption
            :key="item.name"
            v-for="item of deviceInfo.optionList"
            :typeName="item.name"
            :current="item.count"
            :maxCount="item.max"
          ></consumption>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :append-to-body="true"
      width="400"
      :title="this.$t('device.uploadAttData')"
      :visible.sync="uploadDataDia"
    >
      <el-form ref="uploadform" :model="uploadform">
        <el-form-item :label="$t('device.dataRange')">
          <el-date-picker
            v-model="timeValue"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="-"
            :start-placeholder="$t('common.startTime')"
            :end-placeholder="$t('common.endTime')"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.stop="cancelAdd">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitUpload()">
          {{ $t('common.confirm') }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :append-to-body="true"
      width="50%"
      :title="diaTitle"
      @close="closeDia"
      :visible.sync="addDialog"
    >
      <el-form ref="addForm" label-width="180px" :rules="rules" :model="form">
        <el-form-item prop="devSn" :label="this.$t('device.sn')">
          <el-input
            :disabled="isEdit"
            v-model.trim="form.devSn"
            :placeholder="this.$t('device.snRequire')"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item prop="devAlais" :label="this.$t('device.alias')">
          <el-input
            v-model.trim="form.devAlais"
            autocomplete="off"
            :placeholder="this.$t('device.devAlais')"
          ></el-input>
        </el-form-item>

        <el-form-item prop="deviceTimezone" :label="$t('device.Timezone')">
          <el-cascader
            style="width: 100%"
            v-model="form.timezone"
            :options="timezoneList"
            :props="{ checkStrictly: true, value: 'value', label: 'name' }"
            @change="changeCascader"
            filterable
            clearable
          ></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.stop="cancelAdd">{{ $t('common.cancel') }}</el-button>
        <el-button @click="updatDevice()" type="primary">
          {{ $t('common.confirm') }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :append-to-body="true"
      width="50%"
      :title="$t('device.firmwareUpgrade')"
      class="update-dia-cla"
      @close="closeDeviceUpdateDia"
      :visible.sync="deviceUpdateDia"
    >
      <template
        v-if="
          (deviceVersion && historyCurrentVersion !== deviceVersion.version) ||
            isShowUpdate
        "
      >
        <div>
          <div class="update-item-cla">
            <label>{{ $t('device.version') }}：</label>
            <span v-if="deviceVersion">{{ deviceVersion.version }}</span>
          </div>
          <div class="update-item-cla">
            <label>{{ $t('device.firmwaveSize') }}：</label>
            <span v-if="deviceVersion && deviceVersion.size"
              >{{ Math.round(deviceVersion.size / 1024) }}kb</span
            >
            <span v-else>
              {{ $t('device.sizeTip') }}
            </span>
          </div>
          <div class="update-item-cla">
            <label>{{ $t('device.description') }}:</label>
            <div
              class="descript-cla"
              v-if="deviceVersion && deviceVersion.description"
            >
              {{ deviceVersion.description }}
            </div>
            <div class="descript-cla" v-else>{{ $t('device.noInfo') }}</div>
          </div>
        </div>
        <div
          v-if="
            (deviceVersion &&
              historyCurrentVersion !== deviceVersion.version) ||
              isShowUpdate
          "
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click.stop="closeDeviceUpdateDia">{{
            $t('common.cancel')
          }}</el-button>
          <el-button @click="deviceUpgrade()" type="primary">
            {{ $t('device.upgrade') }}
          </el-button>
        </div>
      </template>
      <template v-else>
        <div class="upgrade-info-box" v-if="upgradeStatus === 0">
          <img
            style="width: 100px; height: 100px"
            src="@/assets/new/device/update.svg"
          />
          <div class="upgrade-msg">
            {{ msg }}
          </div>
          <div class="upgrade-tip">
            {{ $t('device.beingUpgraded') }}
          </div>
        </div>

        <div class="upgrade-info-box" v-if="upgradeStatus === 1">
          <img
            style="width: 100px; height: 100px"
            src="@/assets/new/device/sucess.svg"
          />
          <div class="upgrade-msg">
            {{ msg }}
          </div>
          <div class="upgrade-tip">
            {{ $t('device.upgradeSuccessful') }}
          </div>
        </div>
        <div class="upgrade-info-box" v-if="upgradeStatus === 2">
          <img
            style="width: 100px; height: 100px"
            src="@/assets/new/device/error.svg"
          />
          <div class="upgrade-msg">
            {{ $t('device.upgradeFailed') }}
          </div>
          <div class="upgrade-tip">
            {{ msg }}
          </div>
          <el-button @click="deviceUpgrade" type="primary">{{
            $t('device.retry')
          }}</el-button>
        </div>
        <div class="upgrade-info-box" v-if="upgradeStatus === 3">
          <img
            style="width: 100px; height: 100px"
            src="@/assets/new/device/download.svg"
          />
          <div class="upgrade-msg">
            {{ msg }}
          </div>
          <div class="upgrade-tip">
            {{ $t('device.downloadingFirmware') }}
          </div>
        </div>
        <div class="upgrade-info-box" v-if="upgradeStatus === 4">
          <img
            style="width: 100px; height: 100px"
            src="@/assets/new/device/download.svg"
          />
          <div class="upgrade-msg">
            {{ msg }}
          </div>
          <div class="upgrade-tip"></div>
        </div>
        <div class="upgrade-info-box" v-if="upgradeStatus === 5">
          <img
            style="width: 100px; height: 100px"
            src="@/assets/new/device/error.svg"
          />
          <div class="upgrade-msg">
            {{ msg }}
          </div>
          <div class="upgrade-tip">
            {{ $t('device.deviceInternet') }}
          </div>
          <el-button @click="deviceUpgrade" type="primary">{{
            $t('device.retry')
          }}</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog
      :append-to-body="true"
      width="30%"
      :title="$t('device.synData')"
      class="synData-dia-cla"
      :visible.sync="synDataDia"
    >
      <div v-if="synDataSetup === 1">
        <div style="padding:20px">
          <div class="sysData-info-cla">
            <div class="lable-cla">{{ $t('device.dataOperation') }}：</div>
            <div class="checkbox-item">
              <el-checkbox
                true-label="0"
                false-label="1"
                v-model="synDataParams.isClearData"
                >{{ $t('device.removeOldData') }}</el-checkbox
              >
            </div>
          </div>
          <div class="sysData-info-cla" style="margin-top: 20px">
            <div class="lable-cla">{{ $t('device.synInfo') }}：</div>
            <div>
              <div class="checkbox-item">
                <el-checkbox
                  true-label="1"
                  false-label="0"
                  :disabled="true"
                  v-model="synDataParams.baseInfo"
                  >{{ $t('device.baseInfo') }}</el-checkbox
                >
              </div>
              <div class="checkbox-item">
                <el-checkbox
                  true-label="1"
                  false-label="0"
                  v-model="synDataParams.bioTemplateInfo"
                  >{{ $t('device.bioTemplateInfo') }}</el-checkbox
                >
              </div>
              <div class="checkbox-item">
                <el-checkbox
                  true-label="1"
                  false-label="0"
                  v-model="synDataParams.facePhotoInfo"
                  >{{ $t('device.facePhotoInfo') }}</el-checkbox
                >
              </div>
            </div>
          </div>
        </div>
        <div class="foot-bart-cla">
          <el-button type="primary" @click="submitSysData">{{
            $t('device.synbtn')
          }}</el-button>
        </div>
      </div>
      <div v-if="synDataSetup === 2">
        <div class="sysData-tongguo">
          <i class="sysData-icon zk-icon-tongguo"></i>
          <div style="margin-top:10px;padding:10px 20px">
            {{ $t('device.synTip') }}
          </div>
        </div>
        <div class="foot-bart-cla">
          <el-button type="primary" @click="synDataDia = false">{{
            $t('common.yes')
          }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as deviceApi from '@/services/deviceApi.js'
import { Loading } from 'element-ui'
import pickerOptions from '@/utils/pickerOptions.js'
import { getStartTime, getEndTime } from '@/utils/utils.js'
import consumption from './consumption'
export default {
  data() {
    return {
      deviceInfo: {},
      operateEvents: [
        'uploadAttDataEvent',
        'synDataEvent',
        'uploadUserInfoEvent'
      ],
      loadingInstance: null,
      uploadDataDia: false,
      uploadform: {},
      addDialog: false,
      showUpgrade: false,
      upgrageStatus: 0, // 0 详情  1 成功交互   2 失败交互
      pickerOptions: pickerOptions(this),
      form: {
        devSn: '',
        devAlais: '',
        deviceTimezone: '+08:00',
        timezone: '',
        companyId: ''
      },
      timezoneList: [],
      deviceLogo: '',
      deviceVersion: null,
      historyCurrentVersion: '',
      deviceUpdateDia: false,
      upgradeStatus: -1,
      isShowUpdate: false,
      msg: '',
      upgradeTimer: null,
      synDataDia: false,
      synDataSetup: 1,
      synDataParams: {
        isClearData: '0',
        baseInfo: '1',
        bioTemplateInfo: '0',
        facePhotoInfo: '0',
        deviceSn: ''
      }
    }
  },
  props: {
    deviceSn: {
      type: String,
      default: ''
    }
  },
  components: {
    consumption
  },
  watch: {
    deviceSn: {
      handler: function(val, oVal) {
        if (val) {
          this.getDeviceDetails()
          this.getNewest()
        } else {
          this.deviceInfo = {}
        }
      },
      deep: true
    }
  },
  mounted() {
    this.timeValue = []
    let firstDate = new Date()
    firstDate.setDate(1)
    let currentData = new Date()
    this.timeValue.push(firstDate)
    this.timeValue.push(currentData)
    this.getDeviceDetails()
    this.loadTimeZone()
    this.getNewest()
  },
  methods: {
    loadTimeZone() {
      deviceApi
        .getTimeZone()
        .then(data => {
          if (data.code === '00000000') {
            let res = data.payload.results.results
            res.forEach(item => {
              if (item.children && item.children.length === 0) {
                item.children = undefined
              }
            })
            this.timezoneList = res
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(e => {})
    },
    showOffLineTip() {
      if (!this.deviceInfo.enable) {
        this.$message.error(this.$t('device.enableTip'))
        return false
      }
      if (this.deviceInfo && this.deviceInfo.status === 1) {
        return true
      } else {
        this.$message.error(this.$t('device.offLineTip'))
      }
      return false
    },

    getDeviceDetails() {
      if (!this.deviceSn) {
        return false
      }
      let params = {
        devSn: this.deviceSn
      }
      deviceApi
        .getDeviceDetails(params)
        .then(data => {
          if (data.code === '00000000') {
            this.deviceInfo = data.payload.results
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(() => {
          this.errorMessage()
        })
    },
    uploadUserInfoEvent() {
      let isOffline = this.showOffLineTip()
      if (!isOffline) {
        return false
      }
      this.$alert(
        this.$t('device.uploadUser'),
        this.$t('common.warningNotice'),
        {
          confirmButtonText: this.$t('common.yes'),
          callback: action => {
            if (action === 'confirm') {
              this.showLoad()
              let params = {
                deviceSn: this.deviceSn
              }
              deviceApi
                .uploadUserInfoEvent(params)
                .then(this.sucessCallback)
                .catch(this.errorCallback)
            }
          }
        }
      )
    },
    sucessCallback(data) {
      if (this.loadingInstance) {
        setTimeout(() => {
          this.loadingInstance.close()
        }, 500)
      }
      if (data.code === '00000000') {
        this.getDeviceDetails()
      } else {
        this.errorMessage(data.message)
      }
    },
    errorCallback(data) {
      if (this.loadingInstance) {
        this.loadingInstance.close()
      }
      this.errorMessage()
    },
    synDataEvent() {
      //   let isOffline = this.showOffLineTip()
      //   if (!isOffline) {
      //     return false
      //   }
      this.synDataSetup = 1
      this.synDataDia = true
      this.synDataParams.isClearData = '0'
      this.synDataParams.baseInfo = '1'
      this.synDataParams.bioTemplateInfo = '0'
      this.synDataParams.facePhotoInfo = '0'
      this.synDataParams.deviceSn = this.deviceSn

      //   this.$alert(this.$t('device.snycUser'), this.$t('common.warningNotice'), {
      //     confirmButtonText: this.$t('common.yes'),
      //     callback: action => {
      //       if (action === 'confirm') {
      //         this.showLoad()
      //         let params = {
      //           deviceSn: this.deviceSn
      //         }
      //         debugger
      //         deviceApi
      //           .synDataEvent(params)
      //           .then(this.sucessCallback)
      //           .catch(this.errorCallback)
      //       }
      //     }
      //   })
    },
    submitSysData() {
      deviceApi
        .refreshData2Device(this.synDataParams)
        .then(data => {
          if (data.code === '00000000') {
            this.synDataSetup = 2
            this.successMessage()
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage(e)
        })
    },
    showLoad() {
      this.loadingInstance = Loading.service({
        lock: true,
        fullscreen: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    uploadAttDataEvent() {
      let isOffline = this.showOffLineTip()
      if (!isOffline) {
        return false
      }
      this.uploadDataDia = true
    },
    cancelAdd() {
      this.addDialog = false
      this.uploadDataDia = false
    },
    submitUpload() {
      let params = {
        startTime: '',
        endTime: '',
        deviceSn: this.deviceSn
      }
      if (this.timeValue) {
        params.startTime = getStartTime(this.timeValue[0])
        params.endTime = getEndTime(this.timeValue[1])
      }
      this.showLoad()
      deviceApi
        .uploadAttDataEvent(params)
        .then(data => {
          this.uploadDataDia = false
          this.sucessCallback(data)
        })
        .catch(this.errorCallback)
    },

    editEvent() {
      this.diaTitle = this.$t('device.modifyDevice')
      this.addDialog = true
      this.isEdit = true
      this.form.devSn = this.deviceInfo.deviceSn
      this.form.devAlais = this.deviceInfo.deviceName
      this.form.companyId = this.deviceInfo.cmpId
      this.form.deviceTimezone = this.deviceInfo.deviceTimezone || '+08:00'
      if (!this.deviceInfo.timezone) {
        this.form.timezone = [this.deviceInfo.deviceTimezone]
      } else {
        this.form.timezone = [
          this.deviceInfo.deviceTimezone,
          this.deviceInfo.timezone || ''
        ]
      }
    },

    closeDia() {
      this.$refs.addForm.resetFields()
      this.form.timezone = []
    },
    changeCascader(value) {
      try {
        this.form.deviceTimezone = value[0] || null
        this.timezone = [value[0], value[1]]
      } catch (error) {}
    },
    updatDevice() {
      // 更新設備信息
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.form.timezone = this.form.timezone[1]
          deviceApi
            .updateDevice(this.form)
            .then(data => {
              this.addDialog = false
              if (data.code === '00000000') {
                this.getDeviceDetails()
              } else {
                this.errorMessage(data.message)
              }
            })
            .catch(data => {
              this.errorMessage()
            })
        }
      })
    },
    // 获取最新固件
    getNewest() {
      if (!this.deviceSn) {
        return false
      }
      this.queryUpgradeHistory()
      deviceApi
        .getNewest({
          sn: this.deviceSn
        })
        .then(data => {
          if (data.code === '00000000') {
            this.deviceVersion =
              data.payload.results.versions.length > 0
                ? data.payload.results.versions[0]
                : null
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage(e)
        })
    },
    // 固件升级
    deviceUpgrade() {
      if (!this.deviceSn) {
        return false
      }
      if (this.deviceVersion === null) {
        return false
      }

      deviceApi
        .deviceUpgrade({
          sn: this.deviceSn,
          version: this.deviceVersion.version
        })
        .then(data => {
          if (data.code === '00000000') {
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage(e)
        })
    },
    // 获取升级历史
    queryUpgradeHistory(isGetResult) {
      deviceApi
        .queryUpgradeHistory({
          pager: {
            curPage: 1,
            pageSize: 1
          },
          params: {
            sn: this.deviceSn
          }
        })
        .then(data => {
          if (data.code === '00000000') {
            let results = data.payload.results
            if (results && results.length > 0) {
              if (
                isGetResult &&
                (results[0].status === 5 || results[0].status === 2)
              ) {
                this.isShowUpdate = true
              } else {
                this.isShowUpdate = false
              }
              this.upgradeStatus = results[0].status
              this.historyCurrentVersion = results[0].currentVersion
              this.msg = results[0].description
            } else {
              this.msg = ''
              this.upgradeStatus = -1
              this.historyCurrentVersion = ''
            }
          }
        })
        .catch(e => {
          this.errorMessage(e)
        })
    },
    showDeviceUpdateDia() {
      this.deviceUpdateDia = true
      this.queryUpgradeHistory(true)
      this.upgradeTimer = setInterval(() => {
        this.queryUpgradeHistory()
      }, 10000)
    },
    closeDeviceUpdateDia() {
      this.deviceUpdateDia = false
      if (this.upgradeTimer) {
        clearInterval(this.upgradeTimer)
      }
    }
  }
}
</script>
<style scoped lang="less">
@import '~@/styles/var.less';
.device-details-box {
  background-color: #f2f4f6;
  .base-info-box {
    background-color: #ffffff;
    min-height: 250px;
    padding: 0px 20px 40px 20px;
    .device-head-cla {
      display: flex;
      height: 50px;
      line-height: 50px;
      justify-content: space-between;
      border-bottom: 2px solid #f2f4f6;
      align-items: center;
    }
    .base-info-cla {
      display: flex;
      min-height: 200px;
      .device-logo {
        padding-top: 30px;
        text-align: center;
        width: 200px;
      }
      .device-info-box {
        flex-grow: 1;
        padding: 0px 20px;
        .deviceName-cla {
          height: 50px;
          line-height: 50px;
          font-size: 25px;
          font-weight: bold;
        }
        .row-info-cla {
          display: flex;
          height: 50px;
          line-height: 50px;

          .col-item-cla {
            display: flex;
            width: 25%;
            flex-grow: 1;
            align-items: center;
            label {
              font-weight: bold;
            }
          }
        }
      }
      .device-btn-cla {
        margin-top: 30px;
        padding: 5px;
      }
    }
  }
  .info-black-cla {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    min-height: 200px;
    .network-cla {
      padding: 0px 20px 40px 20px;
      width: 50%;
      flex-grow: 1;
      align-items: stretch;
      background-color: #ffffff;
      .network-title-cla {
        height: 50px;
        line-height: 50px;
        border-bottom: 2px solid#F2F4F6;
      }
      .network-box-cla {
        display: flex;
        flex-wrap: wrap;
        .network-item-cla {
          margin-top: 30px;
          width: 50%;
        }
      }
    }
    .usage-cla {
      padding: 0px 20px 40px 20px;
      width: 50%;
      flex-grow: 1;
      align-items: stretch;
      background-color: #ffffff;
      align-items: stretch;
      margin-left: 10px;
      .usage-title-cla {
        height: 50px;
        line-height: 50px;
        border-bottom: 2px solid#F2F4F6;
      }
    }
  }
}

.active-cla {
  width: 8px;
  height: 8px;
  margin-right: 5px;
  border-radius: 5px;
  display: inline-block;
  background-color: @themeColor;
}

.unactive-cla {
  width: 8px;
  height: 8px;
  margin-right: 5px;
  border-radius: 5px;
  display: inline-block;
  background-color: gold;
}
.update-btn-cla {
  margin-left: 20px;
  padding: 0px 10px;
  height: 30px;
  line-height: 30px;
  color: #ffac51;
  background-color: #fffaf5;
  border: none;
  &:hover {
    color: #ffac51;
    background-color: #fffaf5;
  }
}
.update-dia-cla {
  .descript-cla {
    padding-left: 70px;
    margin-top: 15px;
  }
  .update-item-cla {
    margin-bottom: 20px;
  }

  .upgrade-info-box {
    text-align: center;
    padding-top: 20px;
    .upgrade-msg {
      font-weight: bold;
      margin: 20px 0px;
      font-size: 20px;
    }
    .upgrade-tip {
      font-size: 16px;
      margin: 20px 0px;
    }
  }
}
.synData-dia-cla {
  /deep/ .el-dialog__body {
    padding: 0px;
  }
  .foot-bart-cla {
    border-top: 1px solid #0000001a;
    height: 40px;
    line-height: 40px;
    padding-right: 20px;
    text-align: right;
  }
  .sysData-tongguo {
    margin: 40px 0px;
    text-align: center;
  }
  .sysData-icon {
    font-size: 60px;
    color: #4db22f;
  }
}
.sysData-info-cla {
  display: flex;
  .lable-cla {
    height: 32px;
    line-height: 32px;
    margin-right: 30px;
  }
  .checkbox-item {
    height: 32px;
    line-height: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/deviceManager/deviceCmp/deviceDetail.vue